import(/* webpackMode: "eager" */ "/home/runner/work/mira-network/mira-network/playground_v2/src/app/page.tsx");
